import { supabase } from "@/integrations/supabase/client";

export type ClickEvent =
  | "register_click"
  | "login_click"
  | "demo_open"
  | "contact_submit"
  | "nav_click"
  | "footer_click"
  | "audience_selected"
  | "audience_auto_detected"
  | "audience_reset";

const STORAGE_KEY = "tribeo_cookie_consent_v1";

export const hasAnalyticsConsent = () => {
  if (typeof window === "undefined") return false;
  return window.localStorage.getItem(STORAGE_KEY) === "all";
};

export const track = (event: ClickEvent, label?: string) => {
  if (!hasAnalyticsConsent()) return;

  try {
    const payload = {
      event,
      label: label ?? null,
      path: typeof window !== "undefined" ? window.location.pathname : null,
      referrer: typeof document !== "undefined" ? document.referrer || null : null,
      user_agent: typeof navigator !== "undefined" ? navigator.userAgent : null,
      lang: typeof document !== "undefined" ? document.documentElement.lang || null : null,
    };
    void supabase.from("click_events").insert(payload as any).then(({ error }) => {
      if (error) console.warn("track failed", error.message);
    });
  } catch (e) {
    console.warn("track exception", e);
  }
};

export const REGISTER_URL = "https://app.tribeo.co/register";
export const LOGIN_URL = "https://app.tribeo.co/login";
